module.exports = __webpack_public_path__ + "img/intro.ac7bcb76.png";